module.exports = __webpack_public_path__ + "img/5-logo-portada.ae12f8b9.png";